
export interface OmniAuctionState {
    statefulPrice: number;
    auction: any;
    variant: any;
    bidAmount: number;
    placingBid: boolean;
    confirmingBid: boolean;
    purchaseQuantity: number;
}

export interface OmniAction {
    type: string;
    payload: any;
}

export const actions = {
    SET_STATEFUL_PRICE: 'SET_STATEFUL_PRICE',
    SET_AUCTION: 'SET_AUCTION',
    SET_VARIANT: 'SET_VARIANT',
    SET_BID_AMOUNT: 'SET_BID_AMOUNT',
    SET_PLACING_BID: 'SET_PLACING_BID',
    SET_CONFIRMING_BID: 'SET_CONFIRMING_BID',
    SET_PURCHASE_QUANTITY: 'SET_PURCHASE_QUANTITY',
}